import { optional, array, required } from 'AppReact/schema';

export default {
  template_id: optional('integer'),
  templateIdError: optional('string'),
  property_id: optional('integer'),
  propertyIdError: optional('string'),
  unit_ids: array('integer'),
  admin_id: optional('integer'),
  tech_id: optional('integer'),
  tenant_id: optional('integer'),
  name: optional('string'),
  icon: optional('string'),
  isVisible: required('boolean'),
  isAssigning: required('boolean'),
  dueDateCalendarOpen: required('boolean'),
  createError: optional('string'),
  id: optional('integer'),
  nameError: optional('string'),
  occurrenceType: required('string'),
  occurrenceValues: array('string'),
  occurrenceType: required('string'),
  due_date: optional('jsDate')
}

export const defaultNewInspectionModal = {
  template_id: null,
  icon: null,
  templateIdError: null,
  property_id: null,
  propertyIdError: null,
  name: null,
  unit_ids: [],
  admin_id: null,
  id: null,
  occurrenceError: '',
  occurrenceValues: [],
  occurrenceType: 'weekly',
  tech_id: null,
  tenant_id: null,
  isVisible: false,
  isAssigning: false,
  dueDateCalendarOpen: false,
  createError: null,
  nameError: null,
  due_date: null
}